import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: theme.palette.primary.main,
    padding: '20px',
    '& .MuiRadio-root, .MuiFormLabel-root.Mui-focused': {
      color: theme.palette.secondary.contrastText,
    },
    '& .Mui-checked': {
      color: theme.palette.secondary.main,
    },
    '& label, p': {
      color: theme.palette.secondary.contrastText,
      margin: '2px 0 0'
    },
    '& p': {
      fontSize: 12
    },
    '& .dx-texteditor.dx-editor-outlined': {
      borderRadius: 0,
      marginTop: 6
    },
    '& .dx-texteditor-input': {
      height: 37,
      fontSize: '1em',
      paddingLeft: 5
    },
    '& .MuiSelect-select': {
      borderRadius: 0,
      '&:focus': {
        backgroundColor: theme.palette.primary.contrastText,
      },
    },
    '& .MuiInputBase-input': {
      borderRadius: 0,
    },
    '& label.action-button': {
      margin: '0 8px 0 0',
    },
    '& .action-button': {
      marginRight: 8,
      maxWidth: 205,
      padding: '6px 12px',
    },
    '& .documents': {
      '& .document-row': {
        backgroundColor: theme.palette.primary.contrastText,
        border: `solid 1px ${theme.palette.helpers.gray}`,
        borderBottom: 'none',
        '& div': {
          display: 'flex',
          alignItems: 'center',
        },
        '& label': {
          paddingLeft: 5,
          color: theme.palette.primary.main
        },
        '& .header': {
          padding: 5,
          color: theme.palette.secondary.main
        }
      }
    }
  },
  textField: {
    width: 200,
    marginTop: '0px',
    marginBottom: '0px',
  },
  dense: {
    marginTop: 19,
  },
  menu: {
    width: 200,
  }
}));
